/* @flow */

export type Field = null | string | (Object => any);

export default function getField(row: Object, field: any): any {
  if (typeof field === 'function') {
    return field(row);
  } else if (typeof field === 'string') {
    return row[field];
  } else {
    return row;
  }
}
